/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_DescriptionInputs */

const en_upload_description = /** @type {(inputs: Upload_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop your documents here — we'll classify each one. When ready, click Process Documents.`)
};

const pt_br2_upload_description = /** @type {(inputs: Upload_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arraste seus documentos aqui — vamos classificar cada um. Quando estiver pronto, clique em Processar documentos.`)
};

/**
* | output |
* | --- |
* | "Drop your documents here — we'll classify each one. When ready, click Process Documents." |
*
* @param {Upload_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_description = /** @type {((inputs?: Upload_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_description(inputs)
	return pt_br2_upload_description(inputs)
});